
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(193|370|486|518|760|798|82)$/.test(chunkId);
},
rootOutputDir: "../",

    };
}
